import React, { useMemo, useRef, useState } from "react"
import { Grid } from "@mui/material"
import PropTypes from "prop-types"
import ButtonWithIcon from "../Button/Button"
import { ReactComponent as ChatIcon } from "src/v2/assets/icons/chat-icon.svg"
import TextBox from "../TextBox/text-box"
import { dispatchSnackbar } from "src/v2/components/SnackBar/snackbar-bus"
import PromptService from "../../../services/prompt-service"


const RoutinePromptField = ({ value, onChange, tipoDocumento }) => {
    const [open, setOpen] = useState(false)
    const [textoInicialModal, setTextoInicialModal] = useState(value)
    const [carregando, setCarregando] = useState(false)
    const jaBuscouCadastro = useRef(false)
    const promptService = useMemo(() => new PromptService(), [])

    const handleAbrir = async () => {
        if (jaBuscouCadastro.current || value || !tipoDocumento) {
            setTextoInicialModal(value)
            setOpen(true)
            return
        }

        jaBuscouCadastro.current = true
        setCarregando(true)
        try {
            const response = await promptService.getPromptByTipoDocumento(tipoDocumento)
            const cadastrado = response.body?.results?.[0]?.Prompt || ""
            setTextoInicialModal(cadastrado)
        } catch (_) {
            // Sem prompt cadastrado ou falha ao buscar -- abre em branco
            // mesmo, o usuário ainda consegue digitar um prompt novo.
            setTextoInicialModal("")
            dispatchSnackbar("Não foi possível carregar o prompt já cadastrado.", "warning")
        } finally {
            setCarregando(false)
            setOpen(true)
        }
    }

    const handleConfirm = (texto) => {
        onChange(texto)
        setOpen(false)
    }

    return (
        <Grid item>
            <ButtonWithIcon onClick={handleAbrir} icon={<ChatIcon />} disabled={carregando}>
                {value ? "EDITAR PROMPT" : "ADICIONAR PROMPT"}
            </ButtonWithIcon>
            <TextBox
                open={open}
                onClose={() => setOpen(false)}
                onConfirm={handleConfirm}
                initialText={textoInicialModal}
                title="Prompt de sumarização"
                placeholder="Deixe em branco para usar o prompt já cadastrado..."
            />
        </Grid>
    )
}

RoutinePromptField.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    tipoDocumento: PropTypes.string,
}

RoutinePromptField.defaultProps = {
    value: "",
    tipoDocumento: "",
}

export default RoutinePromptField